import Layout from "@components/Layout";
import Title from "@components/Title";
import { useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import { FinancialInstallmentsProvider } from "./FinancialInstallmentsContext";
import FormQuery from "./FormQuery";
import TableFinancialInstallments from "./TableFinancialInstallments";

const Container: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), {
    defaultMatches: true,
  });

  return (
    <Layout enableMargins fullHeight={!isMobile}>
      <Title title="Consultar Partidas" />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <FormQuery />
        <TableFinancialInstallments />
      </div>
    </Layout>
  );
};

const FinancialInstallments: React.FC = () => {
  return (
    <FinancialInstallmentsProvider>
      <Container />
    </FinancialInstallmentsProvider>
  );
};

export { FinancialInstallments };
